import { module } from 'modujs';
import modularLoad from 'modularload';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.setSizes();

        const load = new modularLoad({
            enterDelay: 1200,
            exitDelay: 0,
            transitions: {
            }
        });

        load.on('loading',(transition,oldContainer) => {
            html.classList.remove('has-dom-ready-pre-callback');
            html.classList.remove('has-dom-ready-callback');
            html.classList.remove('has-dom-ready');
            html.classList.remove('has-nav-visible');
            
            this.call('loading',3,'Loading');

        });

        load.on('loaded', (transition, oldContainer, newContainer) => {

            this.setSizes();

            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

        });
    }

    setSizes() {

        // screen height
        document.documentElement.style.setProperty('--app-availheight',`${window.screen.availHeight}px`);
        document.documentElement.style.setProperty('--app-height',`${window.innerHeight}px`);
        document.documentElement.style.setProperty('--app-height-negative',`-${window.innerHeight}px`);

        window.addEventListener('resize',() => {

            if(!window.isMobile) {
                document.documentElement.style.setProperty('--app-availheight',`${window.screen.availHeight}px`);
                document.documentElement.style.setProperty('--app-height',`${window.innerHeight}px`);
                document.documentElement.style.setProperty('--app-height-negative',`-${window.innerHeight}px`);
            }
        });
    }
}
